import { NgModule } from "@angular/core";
import {
  ReportingMoodDistributionComponent
} from "./graphs/reporting-mood-distribution/reporting-mood-distribution.component";
import {
  ReportingParticipationDetailsComponent
} from "./graphs/reporting-participation-details/reporting-participation-details.component";
import { HelpComponent } from './help/help.component';
import { ReportingComponent } from "./reporting.component";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { OverlayModule } from "@angular/cdk/overlay";
import { SavedFilterComponent } from "../filter/saved-filter/saved-filter.component";
import { ReportingPeopleComponent } from "./graphs/reporting-people/reporting-people.component";
import { HighchartsChartComponent } from "highcharts-angular";


@NgModule({
  declarations: [
    ReportingComponent,
    ReportingMoodDistributionComponent,
    ReportingParticipationDetailsComponent,
    ReportingPeopleComponent,
    HelpComponent,
  ],
    imports: [
        SavedFilterComponent,
        CommonModule,
        TranslateModule,
        OverlayModule,
        FormsModule,
        ReactiveFormsModule,
        HighchartsChartComponent,
    ]
})
export class TmReportingModule{
}